import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_TREASURY_MOVEMENT_TYPES = '[TREASURY_MOVEMENT_TYPES] GET_TREASURY_MOVEMENT_TYPES'
export const GET_ACTIVE_TREASURY_MOVEMENT_TYPES = '[TREASURY_MOVEMENT_TYPES] GET_ACTIVE_TREASURY_MOVEMENT_TYPES'
export const SAVE_TREASURY_MOVEMENT_TYPE = '[TREASURY_MOVEMENT_TYPES] SAVE_TREASURY_MOVEMENT_TYPE'
export const VOID_TREASURY_MOVEMENT_TYPE = '[TREASURY_MOVEMENT_TYPES] VOID_TREASURY_MOVEMENT_TYPE'

export function getTreasuryMovementTypesAction() {
  const request = api.get(`/treasury-movement-types/all`)
  return (dispatch) => {
    dispatch({ type: GET_TREASURY_MOVEMENT_TYPES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_TREASURY_MOVEMENT_TYPES, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_TREASURY_MOVEMENT_TYPES, error)
    }).finally(() => {
      dispatch({ type: GET_TREASURY_MOVEMENT_TYPES, payload: { loading: false } })
    })
  }
}

export function getActiveTreasuryMovementTypesAction() {
  const request = api.get(`/treasury-movement-types/actives`)
  return (dispatch) => {
    dispatch({ type: GET_ACTIVE_TREASURY_MOVEMENT_TYPES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ACTIVE_TREASURY_MOVEMENT_TYPES, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_ACTIVE_TREASURY_MOVEMENT_TYPES, error)
    }).finally(() => {
      dispatch({ type: GET_ACTIVE_TREASURY_MOVEMENT_TYPES, payload: { loading: false } })
    })
  }
}

export function saveTreasuryMovementTypeAction(data) {
  const request = api.post(`/treasury-movement-type/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_TREASURY_MOVEMENT_TYPE, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_TREASURY_MOVEMENT_TYPE, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_TREASURY_MOVEMENT_TYPE, error)
    }).finally(() => {
      dispatch({ type: SAVE_TREASURY_MOVEMENT_TYPE, payload: { saving: false } })
    })
  }
}

export function voidTreasuryMovementTypeAction(treasuryMovementTypeId) {
  const request = api.delete(`/treasury-movement-type/${treasuryMovementTypeId}/void`)
  return (dispatch) => {
    dispatch({ type: VOID_TREASURY_MOVEMENT_TYPE, payload: { voiding_id: treasuryMovementTypeId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_TREASURY_MOVEMENT_TYPE, payload: { voided_id: treasuryMovementTypeId } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_TREASURY_MOVEMENT_TYPE, error)
    }).finally(() => {
      dispatch({ type: VOID_TREASURY_MOVEMENT_TYPE, payload: { voiding_id: treasuryMovementTypeId } })
    })
  }
}